require("./background_color_change/global_scope_variables");
require("./background_color_change/form_radio_button");
require("./background_color_change/form_selectbox");
require("./background_color_change/form_checkbox");